import { Modal } from "react-bootstrap";
import useStore from "../hooks/useStore";
import { useEffect, useState } from "react";
import useFlow from "../hooks/useFlow";

export default function EventDetailModal() {
  const {
    showEventDetailModal,
    setShowEventDetailModal,
    getPlansForSchedule,
    setSelectedPopularItem,
    setShowFindClientModal,
    selectedClient,
    setShowCheckoutModal,
  } = useStore();
  const { selectedSchedule } = useFlow();

  const [plans, setPlans] = useState([]);

  useEffect(() => {
    const loadPlans = async () => {
      const data = await getPlansForSchedule(selectedSchedule.scheduleId);
      setPlans(data);
    };
    setPlans([]);
    if (showEventDetailModal) loadPlans();
  }, [showEventDetailModal]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => setShowEventDetailModal(false);

  const handleBuy = (service) => {
    setShowEventDetailModal(false);

    setSelectedPopularItem(service);
    if (selectedClient) setShowCheckoutModal(true);
    else setShowFindClientModal(true);
  };

  return (
    <Modal
      show={showEventDetailModal}
      onHide={handleClose}
      centered
      size="xl"
    >
      <Modal.Body className="p-0">
        <button
          type="button"
          className="btn-close"
          data-testid="event-detail-modal-close-btn"
          onClick={handleClose}
        ></button>

        {selectedSchedule && (
          <div className="row">
            <div
              className="col-md-4 event_image"
              style={{
                backgroundImage: `url(${selectedSchedule.classImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                borderRadius: "1.3rem 0px 0px 1.3rem",
                minHeight: 400,
                backgroundSize: "cover",
              }}
            ></div>
            <div className="col-md-7 p-5 pe-0">
              <div style={{ overflowY: "scroll", maxHeight: 300 }}>
                <h3 className="event_title">{selectedSchedule.name}</h3>
                <p
                  className="event_description"
                  dangerouslySetInnerHTML={{
                    __html: selectedSchedule.description,
                  }}
                />
              </div>

              {plans.length > 0 && (
                <div className="w-100 text-center pt-4 event_pricing_list">
                  {plans.map((plan, idx) => (
                    <a
                      className="btn btn-primary btn-lg mx-1 mt-1 event-checkout-btn"
                      data-testid="event-plan-btn"
                      key={idx}
                      onClick={() => handleBuy(plan)}
                    >
                      <span>{plan.name}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
